import { FaMedal, FaBolt, FaBriefcase, FaBullseye } from 'react-icons/fa6';
import styles from './WhyChoose.module.css';

const reasons = [
  {
    icon: FaMedal,
    title: 'Experiência e especialização',
    description: 'Mais de 7 anos desenvolvendo sites que geram autoridade, reputação e oportunidades reais para o seu negócio.',
    badge: 'Sites únicos',
  },
  {
    icon: FaBolt,
    title: 'Entrega rápida',
    description: 'Seu site pronto em até 15 dias, com um fluxo ágil, checkpoints semanais e a mesma qualidade premium em cada etapa.',
    badge: 'Sem atrasos, sem espera',
  },
  {
    icon: FaBriefcase,
    title: 'Pagamento flexível e seguro',
    description: 'Contrato transparente: 50% para iniciar, 50% na entrega e plano de manutenção acessível para manter seu site impecável.',
    badge: 'Investimento com suporte',
  },
  {
    icon: FaBullseye,
    title: 'Otimizado para conversão',
    description: 'Design pensado para transformar visitantes em clientes no primeiro contato.',
    badge: 'Mais leads, mais clientes',
  },
];

type WhyChooseProps = {
  id?: string;
};

export default function WhyChoose({ id }: WhyChooseProps = {}) {
  return (
    <section id={id} className={styles.wrapper} aria-labelledby="why-heading">
      <div className={styles.container}>
        <header className={styles.header}>
          <span className={styles.subtitle}>Por que me escolher?</span>
          <h2 id="why-heading">
            Pare de se frustrar com <strong>agências demoradas</strong> e freelancers sem o mínimo de experiência.
          </h2>
        </header>

        <div className={styles.grid}>
          {reasons.map(({ icon: Icon, title, description, badge }) => (
            <article key={title} className={styles.card}>
              <div className={styles.cardHeader}>
                <span className={styles.cardIcon} aria-hidden="true">
                  <Icon />
                </span>
                <h3>{title}</h3>
              </div>
              <p>{description}</p>
              <div className={styles.badge} role="group" aria-label={badge}>
                <span aria-hidden="true">✅</span>
                <span>{badge}</span>
              </div>
            </article>
          ))}
        </div>

        <a
          className={styles.ctaButton}
          href="https://wa.me/5535999564940?text=Ol%C3%A1%21%20Acabei%20de%20ver%20a%20se%C3%A7%C3%A3o%20%22Por%20que%20me%20escolher%3F%22%20no%20site%20e%20quero%20um%20site%20que%20venda%20por%20mim."
          target="_blank"
          rel="noreferrer"
        >
          Quero um site que venda por mim!
        </a>
      </div>
    </section>
  );
}
